<template>
  <el-dialog
    title="关联报价商品"
    :visible.sync="goodsDialogVisible"
    width="80%"
    :before-close="handleCancel"
  >
    <div>
      <el-form ref="form" :model="goodsForm" label-width="80px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="商品分类：">
              <el-input disabled v-model="source.cateryname"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="商品标题：">
              <el-input clearable v-model="goodsForm.skuName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="品牌：">
              <el-select
                v-model="goodsForm.propBrandNames"
                @change="handleBrand"
                multiple
                clearable
                placeholder="请选择品牌"
              >
                <el-option
                  v-for="item in propBrandNames"
                  :key="item.brandName"
                  :label="item.brandName"
                  :value="item.brandName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="search">
        <el-button type="primary" @click="submitForm()">搜索</el-button>
        <el-button @click="resetForm()">重置</el-button>
      </div>
      <div class="ccui-multifunctional-table-wrapper">
        <el-table
          height="460px"
          ref="multipleTable"
          :data="tableData"
          :row-style="{ height: '110px' }"
          @selection-change="handleSelectionChange"
          border
        >
          <el-table-column type="selection" width="29" />
          <el-table-column
            class-name="goods-list-commodity-table-header"
            min-width="300"
            label="商品"
          >
            <template slot-scope="scope">
              <div class="clearfix">
                <div class="goods-image">
                  <el-image :src="scope.row.skuMainPic" fit="cover"></el-image>
                </div>

                <div
                  class="goods-list-commodity-table-body-right"
                  style="margin-left: 5px"
                >
                  <div
                    class="goods-list-commodity-table-body-right-item goods-list-commodity-table-body-right-item-title"
                    :title="scope.row.skuName"
                  >
                    {{ scope.row.skuName }}
                  </div>
                  <div
                    :title="scope.row.brandName"
                    class="goods-list-commodity-table-body-right-item"
                  >
                    <span>品牌：{{ scope.row.brandName }}</span>
                  </div>
                  <div class="goods-list-commodity-table-body-right-item">
                    <span>商家商品编码：{{ scope.row.skuId }}</span>
                  </div>
                  <div class="goods-list-commodity-table-body-right-item">
                    <span class="p-goods-label">
                      二级集采
                    </span>
                    <span class="p-goods-label" v-if="scope.row.contractId > 0">
                      协议
                    </span>
                    <span class="p-goods-label" v-if="isDomesticTrade">
                      内贸企业
                    </span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="marketPrice"
            align="right"
            label="市场价"
            :width="allWidth.salePrice"
          >
          </el-table-column>
          <el-table-column
            prop="salePrice"
            align="right"
            label="展示价"
            :width="allWidth.salePrice"
          >
            <template slot-scope="{ row }">
              <el-tooltip effect="dark">
                <template slot="content">
                  <span style="white-space: pre-wrap;">{{
                    row.displayPriceRule
                  }}</span>
                </template>
                <span>{{ row.salePrice }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="basePrice"
            align="right"
            label="基准价"
            :width="allWidth.salePrice"
          >
          </el-table-column>
          <el-table-column
            prop="agreedFixedPrice"
            align="right"
            label="固定费用"
            :width="allWidth.salePrice"
          >
          </el-table-column> -->
          <el-table-column
            prop="unitName"
            label="计量单位"
            align="center"
            :width="allWidth.unitName"
          >
            <template slot-scope="scope">
              <div class="table-cell-text">
                <p>{{ scope.row.unitName }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="skuClassifyPath"
            label="商品分类"
            :width="allWidth.skuClassifyPath"
          >
            <template slot-scope="scope">
              <!--              <div class="table-cell-text">-->
              <!--                <p>{{ scope.row.skuClassifyPath }}</p>-->
              <!--              </div>-->
              <div
                :title="scope.row.skuClassifyPath"
                style="display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 25px;
  white-space: normal;
  height: 100%;
"
              >
                {{ scope.row.skuClassifyPath }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="库存数量" :width="allWidth.skuStatus">
            <template slot-scope="scope">
              <div class="table-cell-text">
                <span>{{ scope.row.stockNum }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            class="time-col"
            prop="putAwayTime"
            label="上架时间"
            :width="allWidth.soldOutTime"
          >
            <template slot-scope="scope">
              <div class="table-cell-text">
                <p style="word-break:keep-all">{{ scope.row.putAwayTime }}</p>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div id="ccui-paging">
          <el-pagination
            :total="totalNum"
            :page-size="pageSize"
            :current-page="pageNo"
            :page-sizes="[10, 20, 50, 100, 200, 500]"
            prev-text="< 上一页"
            next-text="下一页 >"
            background
            layout="total, sizes, prev, pager, next, jumper"
            popper-class="ccui-paging-page-size-popper"
            @prev-click="handlePrev"
            @next-click="handleNext"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
          <el-button
            class="ccui-pagination-btn"
            size="mini"
            type="default"
            @click="handleSizeChange('none')"
            >确定
          </el-button>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确认关联</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  catalogueSkuList,
  querySeekDetailBySkuIdForSupplier
} from "../../../api/all";
import { formatNumber } from "@/basa/utils";

export default {
  props: {
    goodsDialogVisible: {
      type: Boolean,
      default: () => false
    },
    propBrandNames: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    propBrandNames: {
      handler(newVal) {
        this.propBrandOptions = newVal;
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      tableData: [],
      allWidth: {
        marketPrice: 100,
        salePrice: 100,
        agreementPrice: 100,
        unitName: 90,
        stockNum: 80,
        soldOutTime: 155,
        skuClassifyPath: 300,
        operate: 90
      },
      totalNum: 0,
      pageSize: 10,
      pageNo: 1,
      source: {},
      supplierId: "",
      goodsForm: {
        propBrandNames: []
      },
      propBrandLists: [],
      selectRow: [],
      onlyForm: {},
      propBrandOptions: []
    };
  },
  computed: {
    isDomesticTrade() {
      return this.$store.state.app.isDomesticTrade;
    }
  },
  created() {
    this.getTableWidth();
  },
  methods: {
    getTableWidth() {
      let obj = {
        medium: {
          salePrice: 100,
          unitName: 90,
          stockNum: 100,
          soldOutTime: 150,
          operate: 90
        },
        large: {
          salePrice: 100,
          unitName: 90,
          stockNum: 100,
          soldOutTime: 150,
          operate: 90
        }
      };
      const bodyWidth = document.body.clientWidth;
      if (bodyWidth >= 1400 && bodyWidth < 1960) {
        this.allWidth = { ...this.allWidth, ...obj.medium };
      } else if (bodyWidth >= 1960) {
        this.allWidth = { ...this.allWidth, ...obj.large };
      }
    },
    getRowLists(source, supplierId, onlyForm) {
      this.goodsForm.propBrandNames = source.newSkuPropBrand
        ? [source.newSkuPropBrand]
        : [];
      this.goodsForm.code = source.caterycode;
      this.source = source;
      this.onlyForm = onlyForm;
      this.getCataloguaList(this.goodsForm, supplierId);
    },
    getCataloguaList(source, supplierId) {
      let obj = {
        tabId: 1, // 0全部 1已上架 2已下架
        dataScopeId: "",
        isSecondPurchase: 1,
        supplierId: supplierId,
        ...this.goodsForm,
        code: this.source.caterycode
      };
      this.supplierId = supplierId;

      obj.pageNo = this.pageNo;
      obj.pageSize = this.pageSize;
      obj.isShowLoading = true;

      catalogueSkuList(obj).then(res => {
        if (res.data.code === "0") {
          this.tableData = res.data.data.rows.map((item, index) => {
            item.number = index + 1 + (this.pageNo - 1) * this.pageSize;
            item.salePrice = formatNumber(
              item.salePrice ? item.salePrice : 0,
              2,
              true,
              "￥"
            );
            item.marketPrice = formatNumber(
              item.marketPrice ? item.marketPrice : 0,
              2,
              true,
              "￥"
            );
            item.basePrice = formatNumber(
              item.basePrice ? item.basePrice : 0,
              2,
              true,
              "￥"
            );
            item.agreedFixedPrice = formatNumber(
              item.agreedFixedPrice ? item.agreedFixedPrice : 0,
              2,
              true,
              "￥"
            );
            return item;
          });

          if (this.source.newSkuId) {
            this.tableData.forEach(item => {
              if (item.skuId == this.source.newSkuId) {
                this.$nextTick(() => {
                  this.$refs.multipleTable.toggleRowSelection(item);
                });
              }
            });
          }
          this.pageNo = res.data.data.pageNo;
          this.totalNum = res.data.data.recordsTotal;
        }
      });
    },
    handlePrev() {
      console.log("上一页");
    },
    handleNext() {
      console.log("下一页");
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      // val !== 'none' && (this.tableMoudle.pageSize = val)

      if (val !== "none") {
        /** ****梁青竹 存储localStorage列表的条数Begin**********/
        let pageSizeObj = localStorage.getItem("protectPlatPageSize")
          ? JSON.parse(localStorage.getItem("protectPlatPageSize"))
          : {};
        pageSizeObj[this.tableName] = val;
        localStorage.setItem(
          "protectPlatPageSize",
          JSON.stringify(pageSizeObj)
        );
        this.pageSize = val;
        /** ****梁青竹 存储localStorage列表的条数End**********/
      }
      this.getCataloguaList(this.goodsForm, this.supplierId);
    },
    handleCurrentChange(val) {
      // 跳转翻页都会调这个方法
      this.pageNo = val;
      this.getCataloguaList(this.goodsForm, this.supplierId);
    },
    handleCancel() {
      this.source = {};
      this.supplierId = "";
      this.goodsForm = {
        propBrandNames: []
      };
      this.selectRow = [];
      this.$emit("handleDialogCancel");
    },
    handleSubmit() {
      if (this.selectRow.length) {
        querySeekDetailBySkuIdForSupplier({
          skuId: this.selectRow[0].skuId,
          isShowLoading: true,
          ...this.onlyForm
        }).then(res => {
          if (res.data.code == 0) {
            this.selectRow = [];
            this.$emit(
              "handleDialogSubmit",
              res.data.data.seekSupplierQuoteDetails[0]
            );
          }
        });
      } else {
        this.$message({
          message: "请选择商品",
          type: "error",
          duration: 0,
          ccuiCustom: true,
          showClose: true,
          offset: document.body.clientHeight / 2 - 21
        });
      }
    },
    handleSelectionChange(rows) {
      if (rows.length > 1) {
        this.$refs.multipleTable.toggleRowSelection(rows[0]);
      } else {
        this.selectRow = rows;
      }
    },
    submitForm() {
      this.getCataloguaList(this.goodsForm, this.supplierId);
    },
    resetForm() {
      this.goodsForm = {
        propBrandNames: this.propBrandOptions
      };
    },
    handleBrand(val) {
      if (!val.length) {
        this.goodsForm.propBrandNames = this.propBrandOptions.map(item => {
          return item.brandName;
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .ccui-multifunctional-table-wrapper .el-table__header-wrapper th {
  border-right: none;
  background-color: #eeeeee !important;
  color: #9b9b9b !important;
  font-weight: 400 !important;
}

/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

/deep/ input[type="number"] {
  -moz-appearance: textfield !important;
}

.tar {
  text-align: right !important;
}

/deep/ .el-table__body {
  overflow: hidden;
}

/deep/ .el-table__body tr:hover > td {
  background-color: #ffe8ea !important;
  //
  //.goods-list-commodity-table-body-right-item-title {
  //  color: #0089ef;
  //}
}

.ccui-search-bar {
  /*width: 446px!important;*/
}

.clearfix {
  min-height: 110px;
  flex-shrink: 0;

  .goods-image {
    height: 110px;
    flex-shrink: 0;
    width: 100px;

    /deep/ .el-image {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .goods-list-commodity-table-body-right {
    min-height: 110px;
    left: 72px !important;
  }
}

.table-cell-text {
  height: 110px;
  text-align: left;
}

/deep/ tbody .el-table__row .cell {
  padding-top: 12px;
  height: 110px;
}

/deep/
  .el-table__fixed-right
  .el-table__fixed-body-wrapper
  .el-table__row
  td
  .td-button
  .el-button {
  height: 24px !important;
  width: 60px !important;
  padding: 0 2px !important;
  background: #f7f9ff !important;
  border: 1px solid #0089ef !important;
  font-weight: 600 !important;
  border-radius: 4px !important;
  position: relative !important;
  margin-top: 2px;
}

/deep/
  .el-table__fixed-right
  .el-table__fixed-body-wrapper
  .el-table__row
  td
  .td-button
  .el-button
  span {
  color: #0089ef !important;
}

/deep/ .goods-list-commodity-table-body-center {
  margin-top: 0 !important;
}

/deep/
  .el-table__fixed-right
  .el-table__fixed-body-wrapper
  .el-table__row
  td
  .cell {
  padding-top: 12px;

  .table-cell-text {
    text-align: center;
  }
}

/deep/ .goods-list-commodity-table-header {
  .cell {
    > div {
      display: flex;
    }
  }

  .el-input__suffix {
    right: 15px;
  }
}

/deep/ .el-table__fixed-right .el-table__fixed-body-wrapper {
  margin-top: 0;
}

.el-table--border
  .el-table__body-wrapper
  .goods-list-commodity-table-body-right
  .goods-list-commodity-table-body-right-item {
  height: 20px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.el-table--border .el-table__body-wrapper .goods-image .goods-status {
  top: 0;
  bottom: 50px;
}

.el-table--border
  .el-table__body-wrapper
  .goods-list-commodity-table-body-center {
  height: 60px;
  width: 60px;
}

.el-table--border .el-table__body-wrapper .goods-image {
  height: 110px;
}

.p-goods-label {
  font-size: 12px;
  color: #ffffff;
  line-height: 18px;
  text-align: center;
  // width: 60px;
  padding: 0 5px;
  height: 18px;
  background: #ff142f;
  border-radius: 2px;
  display: inline-block;
}

.search {
  display: flex;
  justify-content: center;
  padding: 10px 0;
}

/deep/ .el-select .el-select__tags > span {
  display: flex;
  overflow: hidden;
}
</style>
